import * as React from 'react'
import styled from 'styled-components'

interface SelectPlaceHolderProps {
    label?: string
    style?: React.CSSProperties
    color?: string
}
const SCxContainer = styled.div<{ color?: string }>`
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: var(--font-size-normal);
    font-weight: var(--font-weight-normal);
    color: ${({ color }) => color || 'var(--color-gray-300)'};
`

export const SelectPlaceHolder: React.FunctionComponent<SelectPlaceHolderProps> = ({ label = '', style, color }) => {
    return (
        <SCxContainer style={style} color={color}>
            {label}
        </SCxContainer>
    )
}
